import { render, staticRenderFns } from "./addRedEnvelopeRain.vue?vue&type=template&id=6a1fa5bb&scoped=true&"
import script from "./addRedEnvelopeRain.vue?vue&type=script&lang=js&"
export * from "./addRedEnvelopeRain.vue?vue&type=script&lang=js&"
import style0 from "./addRedEnvelopeRain.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addRedEnvelopeRain.vue?vue&type=style&index=1&id=6a1fa5bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1fa5bb",
  null
  
)

component.options.__file = "addRedEnvelopeRain.vue"
export default component.exports